import { NOTIFICATION_ALERT } from "../constants/constants";

const initialState = {
  notificationAlert: false,
};

const notificationAlert = (state, action) => {
  if (typeof state === "undefined") {
    return initialState;
  } else {
    if (action.type === NOTIFICATION_ALERT) {
      return {
        ...state,
        ...action.payload,
      };
    } else {
      return state;
    }
  }
};
export default notificationAlert;
